
if (!customElements.get('bundle-purchase-card')) {
  class BundlePurchaseCard extends HTMLElement {
    connectedCallback() {
      // Re-run safely if the node is re-inserted (grid-custom rebuilds innerHTML on mobile).
      if (this._bound) return;
      this._bound = true;

      this.variants = this._parseVariants();
      this.idInputs = this.querySelectorAll('.tt-bundle-card__variant-id');
      this.optionLists = this.querySelectorAll('.tt-bundle-card__option');
      this.priceCurrent = this.querySelector('.tt-bundle-card__price-current');
      this.priceCompare = this.querySelector('.tt-bundle-card__price-compare');
      this.discountTag = this.querySelector('.tt-bundle-card__discount-tag');
      this.image = this.querySelector('.tt-bundle-card__image');
      /* 记录初始卡图：切到无变体图的 variant 时回退初始图而非停留上一变体图 (DTC-1056) */
      this._initialImgSrc = this.image ? this.image.getAttribute('src') : null;
      this.atcBtn = this.querySelector('.tt-bundle-card__btn--atc');
      this.atcLabel = this.querySelector('.tt-bundle-card__btn-label');
      this.buyBtn = this.querySelector('.tt-bundle-card__btn--buy');

      this.addEventListener('click', (e) => {
        const el = e.target.closest('.tt-bundle-card__option-item');
        if (el) this._onSelect(el);
      });
      this.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          const el = e.target.closest('.tt-bundle-card__option-item');
          if (el) { e.preventDefault(); this._onSelect(el); }
        }
      });
    }

    _parseVariants() {
      const node = this.querySelector('.tt-bundle-card__variants');
      if (!node) return [];
      try {
        return JSON.parse(node.textContent);
      } catch (e) {
        console.warn('bundle-purchase-card: invalid variants JSON', e);
        return [];
      }
    }

    _onSelect(el) {
      const list = el.closest('.tt-bundle-card__option');
      if (!list || el.classList.contains('active')) return;
      list
        .querySelectorAll('.tt-bundle-card__option-item')
        .forEach((i) => i.classList.remove('active'));
      el.classList.add('active');
      this._update(list, el);
    }

    /* Variant ID 白名单可能构成不完整选项矩阵：按 variant 回写各 option 的 active 态 (DTC-1056) - Sharon - 2026-08-20 */
    _syncActive(variant) {
      this.optionLists.forEach((list) => {
        const pos = parseInt(list.dataset.optionPosition, 10);
        if (!pos) return;
        const target = variant.options[pos - 1];
        list.querySelectorAll('.tt-bundle-card__option-item').forEach((i) => {
          i.classList.toggle('active', i.dataset.value === target);
        });
      });
    }

    _selectedValues() {
      const values = [];
      this.optionLists.forEach((list) => {
        const pos = parseInt(list.dataset.optionPosition, 10);
        const active = list.querySelector('.tt-bundle-card__option-item.active');
        if (active && pos) values[pos - 1] = active.dataset.value;
      });
      return values;
    }

    _update(clickedList, clickedEl) {
      const selected = this._selectedValues();
      let variant = this.variants.find(
        (v) =>
          Array.isArray(v.options) &&
          v.options.length === selected.length &&
          v.options.every((o, i) => o === selected[i])
      );
      /* 精确匹配失败(白名单造成组合缺口)时，纠偏到含刚点击值的 variant（优先可售）并同步 active 态；
         仅白名单启用的卡片(data-vfilter)走此路径，存量实例行为与原版一致 (DTC-1056) - Sharon - 2026-08-20 */
      if (!variant && clickedList && clickedEl && this.hasAttribute('data-vfilter')) {
        const pos = parseInt(clickedList.dataset.optionPosition, 10);
        const val = clickedEl.dataset.value;
        if (pos && val != null) {
          const pool = this.variants.filter(
            (v) => Array.isArray(v.options) && v.options[pos - 1] === val
          );
          variant = pool.find((v) => v.available === true) || pool[0];
          if (variant) this._syncActive(variant);
        }
      }
      if (!variant) return;

      this.idInputs.forEach((input) => {
        input.value = variant.id;
      });

      if (this.priceCurrent && variant.price_html) {
        this.priceCurrent.innerHTML = variant.price_html;
      }
      if (this.priceCompare) {
        if (variant.has_compare && variant.compare_html) {
          this.priceCompare.innerHTML = variant.compare_html;
          this.priceCompare.style.display = '';
        } else {
          this.priceCompare.style.display = 'none';
        }
      }
      if (this.discountTag) {
        if (variant.has_compare && variant.discount > 0) {
          this.discountTag.textContent = '-' + variant.discount + '%';
          this.discountTag.style.display = '';
        } else {
          this.discountTag.style.display = 'none';
        }
      }
      if (this.image) {
        if (variant.image) {
          this.image.src = variant.image;
        } else if (this._initialImgSrc) {
          this.image.src = this._initialImgSrc;
        }
      }

      const available = variant.available === true;
      [this.atcBtn, this.buyBtn].forEach((btn) => {
        if (btn) btn.disabled = !available;
      });
      if (this.atcLabel) {
        this.atcLabel.textContent = available
          ? this.atcBtn?.dataset.addLabel ||
            window.variantStrings?.addToCart ||
            'Add To Cart'
          : this.atcBtn?.dataset.soldLabel ||
            window.variantStrings?.soldOut ||
            'Sold Out';
      }
    }
  }

  customElements.define('bundle-purchase-card', BundlePurchaseCard);
}
